/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
} from './FindAllSourceTags200ResponseDataInner';
import type { GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner } from './GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON,
} from './GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner';

/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseDataSourceToMergeSource
 */
export interface GetSourceMergePreview200ResponseDataSourceToMergeSource {
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    location?: string | null;
    /**
     * 
     * @type {Array<GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner>}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    contacts?: Array<GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    npi_number?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    fax_numbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    tag_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    type?: GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum;
    /**
     * 
     * @type {FindAllSourceTags200ResponseDataInner}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSource
     */
    tag?: FindAllSourceTags200ResponseDataInner;
}


/**
 * @export
 */
export const GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum = {
    Hospital: 'Hospital',
    HomeCare: 'Home Care',
    Hospice: 'Hospice',
    AssistedLiving: 'Assisted Living',
    Other: 'Other',
    SkilledNursingFacility: 'Skilled Nursing Facility',
    IndependentLiving: 'Independent Living',
    Physician: 'Physician',
    LongTermAcuteCare: 'Long-Term Acute Care'
} as const;
export type GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum = typeof GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum[keyof typeof GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum];


/**
 * Check if a given object implements the GetSourceMergePreview200ResponseDataSourceToMergeSource interface.
 */
export function instanceOfGetSourceMergePreview200ResponseDataSourceToMergeSource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSource {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseDataSourceToMergeSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'contacts': !exists(json, 'contacts') ? undefined : ((json['contacts'] as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON)),
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'npi_number': !exists(json, 'npi_number') ? undefined : json['npi_number'],
        'fax_numbers': !exists(json, 'fax_numbers') ? undefined : json['fax_numbers'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'tag_id': !exists(json, 'tag_id') ? undefined : json['tag_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'tag': !exists(json, 'tag') ? undefined : FindAllSourceTags200ResponseDataInnerFromJSON(json['tag']),
    };
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSON(value?: GetSourceMergePreview200ResponseDataSourceToMergeSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'location': value.location,
        'contacts': value.contacts === undefined ? undefined : ((value.contacts as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON)),
        'phone': value.phone,
        'npi_number': value.npi_number,
        'fax_numbers': value.fax_numbers,
        'email': value.email,
        'tag_id': value.tag_id,
        'type': value.type,
        'tag': FindAllSourceTags200ResponseDataInnerToJSON(value.tag),
    };
}

